module.exports = __webpack_public_path__ + "static/media/universe.f57bc5f8.jpg";